import React from 'react';
import { useLocation } from 'react-router-dom';
import './AcceptedOrderThankYouPage.css';

const AcceptedOrderThankYouPage = () => {
    const location = useLocation();

    const { orderSlug } = location.state || {};

    return (
        <div className="accepted-success-wrapper min-vh-100 d-flex align-items-center justify-content-center">
            <div className="success-particles">
                <div className="particle particle-1"></div>
                <div className="particle particle-2"></div>
                <div className="particle particle-3"></div>
            </div>
            
            <div className="accepted-success-card text-center">
                <div className="success-icon-wrapper mb-4">
                    <svg className="success-checkmark" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 52 52">
                        <circle className="success-checkmark__circle" cx="26" cy="26" r="25" fill="none" />
                        <path className="success-checkmark__check" fill="none" d="M14.1 27.2l7.1 7.2 16.7-16.8" />
                    </svg>
                </div>
                
                <h1 className="success-title mb-3">Order Accepted!</h1>
                
                <p className="success-message mb-4">
                    You've successfully accepted your order {orderSlug ? <span className="order-highlight">#{orderSlug}</span> : ''}.
                </p>
                
                <div className="success-divider"></div>
                
                <p className="success-subtext">
                    Thank you for choosing us. We look forward to your next order!
                </p>
            </div>
        </div>
    );
};

export default AcceptedOrderThankYouPage;
